import React from "react";
import { AlertCircle, AlertTriangle, CheckCircle2, Clock, Copy, Info, Mail, Pause, Play, RefreshCw, Send, X } from "lucide-react";
import { Spinner } from "../../atoms/Spinner";
import type { ToastIcon, ToastKind } from "./Toast.types";

const KIND_ICON: Record<Exclude<ToastKind, "progress">, React.ReactNode> = {
  success: <CheckCircle2 aria-hidden="true" />,
  info: <Info aria-hidden="true" />,
  warning: <AlertTriangle aria-hidden="true" />,
  error: <AlertCircle aria-hidden="true" />,
};

const GLYPH: Record<ToastIcon, React.ReactNode> = {
  send: <Send aria-hidden="true" />,
  mail: <Mail aria-hidden="true" />,
  pause: <Pause aria-hidden="true" />,
  play: <Play aria-hidden="true" />,
  clock: <Clock aria-hidden="true" />,
  refresh: <RefreshCw aria-hidden="true" />,
  copy: <Copy aria-hidden="true" />,
};

/** A notification's icon: a spinner while in progress, else its own glyph or its kind's. Shared by Toast and ActivityList. */
export const ToastGlyph: React.FC<{ kind: ToastKind; icon?: ToastIcon | null }> = ({ kind, icon = null }) => (
  <>{kind === "progress" ? <Spinner size={16} /> : icon ? GLYPH[icon] : KIND_ICON[kind]}</>
);

/** The dismiss glyph, shaped for the IconButton atom (a component of `{ size }`). */
export const DismissIcon: React.FC<{ size?: number }> = ({ size }) => <X size={size} aria-hidden="true" />;

export default ToastGlyph;
